import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Heading } from '@chakra-ui/react'
import Results from "./ResultTable.tsx";
import ResultForm from "./ResultForm.tsx";

export default function PageContent() {
    return <Tabs variant='unstyled' colorScheme='green' align="center" m={5} defaultIndex={1}>
        <TabList>
            <Tab _selected={{ color: 'white', bg: 'green.300' }}>
                <Heading size={'md'} as={'h3'}>
                    Încărcare sursă
                </Heading>
            </Tab>
            <Tab _selected={{ color: 'white', bg: 'green.300' }}>
                <Heading size={'md'} as={'h3'}>
                    Vizualizare rezultate
                </Heading>
            </Tab>
        </TabList>
        <TabPanels>
            <TabPanel>
                <ResultForm />
            </TabPanel>
            <TabPanel>
                <Results />
            </TabPanel>
        </TabPanels>
    </Tabs>
}